<template>
	<div>
		<div class="product-add">
			<!--form表单-->
			<el-form size="small" ref="form" :model="form" label-width="200px">
				<!--添加店员-->
				<div class="common-form">添加技师</div>
				<el-form-item label="技师姓名" prop="username" :rules="[{ required: true, message: ' ' }]">
					<el-input class="max-w460" v-model="form.username" placeholder="请输入技师名称"></el-input>
				</el-form-item>
				<el-form-item label="技师昵称" prop="nickName" :rules="[{ required: true, message: ' ' }]">
					<el-input class="max-w460" v-model="form.nickName" placeholder="请输入技师名称"></el-input>
				</el-form-item>
				<el-form-item label="技师手机号" prop="mobile" :rules="[{ required: true, message: ' ' }]">
					<el-input class="max-w460" type="number" v-model="form.mobile" placeholder="请输入技师手机号"></el-input>
				</el-form-item>
				<el-form-item label="登录密码" prop="password" :rules="[{ required: true, message: ' ' }]">
					<el-input v-model="form.password" placeholder="请输入登录密码" :type="flag?'password':''" class="max-w460">
						<template slot="append">
							<i slot="suffix" :class="[flag ? 'fa fa-eye-slash' : 'el-icon-view']" autocomplete="auto"
								@click="flag = !flag" />

						</template>
					</el-input>
				</el-form-item>
				<el-form-item label="类型">
					<el-radio-group v-model="form.gender">
						<el-radio :label="0">全职</el-radio>
						<el-radio :label="1">兼职</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="技师性别">
					<el-radio-group v-model="form.is_fulltime">
						<el-radio :label="1">男</el-radio>
						<el-radio :label="2">女</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="头像">
					<el-row>
						<el-button icon="el-icon-picture-outline" @click="openUpload('avatarUrl')">选择图片</el-button>
						<div v-if="form.avatarUrl != ''" class="img">
							<img :src="form.avatarUrl" width="100" height="100" />
						</div>
					</el-row>
				</el-form-item>
				<el-form-item label="是否虚拟技师">
					<el-radio-group v-model="form.isVirtual">
						<el-radio :label="0">正常技师</el-radio>
						<el-radio :label="1">虚拟技师</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="年龄" prop="age" :rules="[{ required: true, message: ' ' }]">
					<el-input class="max-w460" type="number" min="1" max="300" v-model="form.age" placeholder="请输入技师年龄"></el-input>
				</el-form-item>
				<el-form-item label="所属商户">
					<el-select v-model="form.shopSupplierId" placeholder="请选择">
						<el-option v-for="(item, index) in supplierList" :key="index" :label="item.name"
							:value="item.shopSupplierId">
						</el-option>
					</el-select>
				</el-form-item>

				<div class="common-button-wrapper">
					<el-button size="small" type="info" @click="cancelFunc">取消</el-button>
					<el-button size="small" type="primary" @click="onSubmit">提交</el-button>
				</div>
			</el-form>

			<!--上传图片组件-->
			<Upload v-if="isupload" :isupload="isupload" :type="type" @returnImgs="returnImgsFunc">上传图片</Upload>

		</div>
	</div>
</template>

<script>
	import Technician from "@/api/technician.js";
	import Upload from "@/components/file/Upload";
	export default {
		components: {
			/*上传组件*/
			Upload,
			/*选择用户*/
		},
		data() {
			return {
				form: {
					shopSupplierId: "", //商户id
					username: '', //姓名
					nickName: '', //昵称
					password: '', //密码
					gender: 1, //1男 2女
					is_fulltime: 0, // 0全职  1兼职
					age: '', //年龄
					mobile: '', //手机号
					avatarUrl: '', //头像
					isVirtual: 0
					// 生日
				},
				isupload: false,
				flag: true,
				supplierList: []
			};
		},
		created() {
			this.getTableList()
		},
		methods: {
			/*上传*/
			openUpload(e) {
				this.type = e;
				this.isupload = true;
			},
			getTableList() {
				let self = this;
				let Params = {}
				Params.pageIndex = self.curPage;
				Params.pageSize = self.pageSize;
				Technician.getnewWaiter(Params, true)
					.then(data => {
						self.loading = false;
						self.supplierList = data.data.supplier;

					})
					.catch(error => {
						self.loading = false;
					});
			},
			/*获取图片*/
			returnImgsFunc(e) {
				if (e != null && e.length > 0) {
					if (this.type == "avatarUrl") {
						this.form.avatarUrl = e[0].filePath;
					}
				}
				this.isupload = false;
			},

			/*取消*/
			cancelFunc() {
				this.$router.back(-1);
			},
			onSubmit() {
				let self = this;

				self.$refs.form.validate(valid => {
					if (valid) {
						let Params = this.form
						Technician.addwaiter(Params, true)
							.then(data => {
								self.$message({
									message: data.msg,
									type: "success"
								});
								setTimeout(() => {
									self.cancelFunc()

								}, 1000)
							})
							.catch(error => {});
					}
				});
			}
		}
	};
</script>




<style>
	.edit_container {
		font-family: "Avenir", Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		line-height: 20px;
		color: #2c3e50;
	}

	.ql-editor {
		height: 400px;
	}

	.draggable-list {
		display: flex;
		justify-content: flex-start;
		flex-wrap: wrap;
	}

	.draggable-list .wrapper>span {
		display: flex;
		justify-content: flex-start;
		flex-wrap: wrap;
	}

	.draggable-list .item {
		position: relative;
		width: 110px;
		height: 110px;
		margin-top: 10px;
		margin-right: 10px;
		border-radius: 8px;
		overflow: hidden;
		border: 1px solid #dddddd;
	}

	.draggable-list .delete-btn {
		position: absolute;
		top: 0;
		right: 0;
		width: 16px;
		height: 16px;
		background: red;
		line-height: 16px;
		font-size: 16px;
		color: #ffffff;
		display: none;
	}

	.draggable-list .item:hover .delete-btn {
		display: block;
	}

	.draggable-list .item img {
		position: absolute;
		top: 50%;
		left: 50%;
		-webkit-transform: translate(-50%, -50%);
		transform: translate(-50%, -50%);
		max-height: 100%;
		max-width: 100%;
	}

	.draggable-list .img-select {
		display: flex;
		justify-content: center;
		align-items: center;
		border: 1px dashed #dddddd;
		font-size: 30px;
	}

	.draggable-list .img-select i {
		color: #409eff;
	}
</style>


// WEBPACK FOOTER //
// src/views/technician/technicianlist/add.vue